<script setup lang="ts">
import type { Image, Video } from '@design-system/components/UI/UIMedia.props'
import type {
  HomepageBrandCardWrapper,
  BrandCardResponse,
} from './HomepageBrandCardWrapper.props'

const props = defineProps<HomepageBrandCardWrapper>()

const mainMedia = computed<Image | Video>(() => {
  const { mainMedia, hoverMedia } = props.card
  if (
    !props.version2 &&
    mainMedia?.type === 'video' &&
    hoverMedia?.type === 'image' &&
    hoverMedia.src
  ) {
    return createMedia(hoverMedia.type, hoverMedia.src, hoverMedia.alt)
  }
  return createMedia(mainMedia.type, mainMedia.src, mainMedia.alt)
})

const hoverMedia = computed<Image | Video>(() => {
  const { hoverMedia, mainMedia } = props.card
  const media = hoverMedia.src ? hoverMedia : mainMedia
  return createMedia(media.type, media.src, media.alt)
})
const logoType = computed<BrandCardResponse['bannerLogo']['type']>(() => {
  if (props.card.brand === 'armani-exchange' && !props.version2) {
    return 'monogram'
  } else return props.card.bannerLogo.type
})
const target = ref(null)
const targetIsVisible = ref(false)

const { stop } = useIntersectionObserver(
  target,
  ([{ isIntersecting }]) => {
    targetIsVisible.value = isIntersecting
  },
  { threshold: [0.5, 1] }
)

const fetchPriorityImageByIntersection = computed(() => {
  return targetIsVisible.value || props.fetchPriorityImage
})

onUnmounted(() => {
  stop()
})
</script>

<template>
  <div ref="target" class="card-container relative overflow-hidden">
    <HomepageCard
      class="card main-media-card homepage-categories-card !block !h-full"
      :link="{ ...card.link, outlineOffset: false }"
      :brand="card.brand"
      :media-type="mainMedia.type"
      :media="mainMedia"
      :hover-media="hoverMedia"
      :fetch-priority-image="fetchPriorityImageByIntersection"
      :video-dark-overlay="card.hoverLogo && card.hoverLogo.overlayBackground"
      :is-portrait-card="isPortraitCard"
      :is-playable="targetIsVisible"
      :show-loading="true"
      :logo-text-inside-link="true"
    >
      <template #banner-logo>
        <HomepageCardBannerLogo
          :brand="card.brand"
          :banner-logo-type="logoType"
          class="bg-primitives-white"
        />
      </template>
      <template v-if="version2 && card.firstLabel.label" #banner-text>
        <p>{{ card.firstLabel.label }}</p>
      </template>
    </HomepageCard>
  </div>
</template>
